import moment from "moment";

export const getType = (type) => {
  switch (type) {
    case 'mineSite':
      return 'Mine Site';
    case 'village':
      return 'Village';
    default:
      return 'Location';
  }
}

export const dateFormat = (type, date) => {
  switch (type) {
    case 'daily':
    case 'threeMonths':
    case 'weekly':
    case 'monthly':
    case 'year':
      return date.format('YY MM DD').toString();
    default:
      return date.toISOString();
  }
}

export const getDateRanges = (type) => {
  switch (type) {
    case 'daily':
      return [moment()].map((d) => dateFormat('weekly', d));
    case 'weekly':
      return Array.from(moment.range(
        moment().subtract(1, 'weeks'),
        moment()
      ).by('day')).map((d) => dateFormat('weekly', d));
    case 'monthly':
      return Array.from(moment.range(
        moment().subtract(1, 'months'),
        moment()).by('day')
      ).map((d) => dateFormat('monthly', d));
    case 'threeMonths':
      return Array.from(moment.range(
        moment().subtract(3, 'months'),
        moment()).by('day')
      ).map((d) => dateFormat('monthly', d));
    case 'year':
      return Array.from(moment.range(
        moment().subtract(12, 'months'),
        moment()).by('day')
      ).map((d) => dateFormat('monthly', d));
    default:
      return [];
  }
}

export const filterValidGPS = (data) => {
  const latCheck = (lat) => lat > -90 || lat < 90;
  const lngCheck = (lng) => lng > -180 || lng < 180;
  return data.filter(item => {
    return item.marker &&
      latCheck(Number(item.marker.lat)) &&
      lngCheck(Number(item.marker.lng));
  });
}

export const riskTypesOptions = [
  {
    label: {
      en: 'Legality',
      fr: 'Légalité',
    },
    value: 'legality',
  },
  {
    label: {
      en: 'Human Rights',
      fr: 'Droits humains',
    },
    value: 'humanRights',
  },
  {
    label: {
      en: 'Conflict & Security',
      fr: 'Conflit & Sécurité',
    },
    value: 'conflictSecurity',
  },
  {
    label: {
      en: 'Environment & Natural Resources',
      fr: 'Environnement & Ressources naturelles',
    },
    value: 'environment',
  },
  {
    label: {
      en: 'Health & Safety',
      fr: 'Santé et sécurité au travail',
    },
    value: 'healthSafety',
  },
  {
    label: {
      en: 'Community & Society',
      fr: 'Communauté & Société',
    },
    value: 'communitySociety',
  },
];

export const riskSubTypesOptions = [
  {
    label: { en: 'Illegality of the sector', fr: 'Illégalité du secteur' },
    value: 'illegalityOfTheSector',
    filter: { riskTypes: 'legality' }
  },
  {
    label: {
      en: 'Illegal mining operations',
      fr: 'Opérations minières illégales'
    },
    value: 'illegalMiningOperations',
    filter: { riskTypes: 'legality' }
  },
  {
    label: {
      en: 'Illegal supply chain actors',
      fr: "Acteurs illégaux de la chaîne d'approvisionnement"
    },
    value: 'illegalSupplyChainActors',
    filter: { riskTypes: 'legality' }
  },
  {
    label: {
      en: 'Contradictory claims',
      fr: 'Revendications contradictoires'
    },
    value: 'contradictoryClaims',
    filter: { riskTypes: 'legality' }
  },
  {
    label: { en: 'Missing evidence', fr: 'Manque de preuves' },
    value: 'missingEvidence',
    filter: { riskTypes: 'legality' }
  },
  {
    label: { en: 'Money laundering', fr: "Blanchiment d'argent" },
    value: 'moneyLaundering',
    filter: { riskTypes: 'legality' }
  },
  {
    label: {
      en: 'Issue with payments to government',
      fr: 'Problème de paiements au gouvernement'
    },
    value: 'issueWithGovernmentPayments',
    filter: { riskTypes: 'legality' }
  },
  {
    label: {
      en: 'Extortion / Illegal taxation',
      fr: 'Extorsion / Taxe illégale'
    },
    value: 'extortion',
    filter: { riskTypes: 'legality' }
  },
  {
    label: {
      en: 'Presence and interference of public or private security forces',
      fr: 'Présence et interférence des forces de sécurité publiques ou privées'
    },
    value: 'presenceSecurityForces',
    filter: { riskTypes: 'legality' }
  },
  {
    label: { en: 'Illegal control', fr: 'Contrôle illégal' },
    value: 'illegalControl',
    filter: { riskTypes: 'legality' }
  },
  {
    label: { en: 'Illegal trade', fr: 'Commerce illégal' },
    value: 'illegalTrade',
    filter: { riskTypes: 'legality' }
  },
  {
    label: {
      en: 'Corruption, bribery and facilitation',
      fr: 'Corruption, pots-de-vin et facilitation'
    },
    value: 'corruption',
    filter: { riskTypes: 'legality' }
  },
  {
    label: {
      en: 'Supply chain contamination',
      fr: "Contamination de la chaîne d'approvisionnement"
    },
    value: 'contamination',
    filter: { riskTypes: 'legality' }
  },
  {
    label: { en: 'Torture', fr: 'Torture' },
    value: 'torture',
    filter: { riskTypes: 'humanRights' }
  },
  {
    label: {
      en: 'Cruel, inhumane, degrading treatment',
      fr: 'Traitements cruels, inhumains, dégradants'
    },
    value: 'cruel',
    filter: { riskTypes: 'humanRights' }
  },
  {
    label: {
      en: 'Abusive disciplinary practices',
      fr: 'Pratiques disciplinaires abusives'
    },
    value: 'abusiveDisciplinary',
    filter: { riskTypes: 'humanRights' }
  },
  {
    label: { en: 'Discrimination', fr: 'Discrimination' },
    value: 'discrimination',
    filter: { riskTypes: 'humanRights' }
  },
  {
    label: { en: 'Forced labour', fr: 'Travail forcé' },
    value: 'forcedLabour',
    filter: { riskTypes: 'humanRights' }
  },
  {
    label: { en: 'Child labour', fr: 'Travail des enfants' },
    value: 'childLabour',
    filter: { riskTypes: 'humanRights' }
  },
  {
    label: { en: 'Sexual exploitation', fr: 'Exploitation sexuelle' },
    value: 'sexualExploitation',
    filter: { riskTypes: 'humanRights' }
  },
  {
    label: { en: 'Human trafficking', fr: 'Traite des êtres humains' },
    value: 'humanTrafficking',
    filter: { riskTypes: 'humanRights' }
  },
  {
    label: {
      en: 'Violence against civilians',
      fr: 'Violence contre des civils'
    },
    value: 'violenceAgainstCivilians',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: {
      en: 'Abduction / kidnapping of civilians',
      fr: 'Enlèvement / Kidnapping de civils'
    },
    value: 'kidnappingOfCivilians',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: {
      en: 'Clash / Confrontation between groups',
      fr: 'Affrontement / Confrontation entre groupes'
    },
    value: 'groupClash',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: {
      en: 'Armed group presence or incursion',
      fr: "Présence ou incursion d'un groupe armé"
    },
    value: 'armedGroupPresence',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: {
      en: 'Identity-based conflict or tension',
      fr: 'Conflit ou tension à base identitaire'
    },
    value: 'identityBasedConflictOrTension',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: { en: 'War crime', fr: 'Crime de guerre' },
    value: 'warCrime',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: {
      en: 'Crime against humanity or genocide',
      fr: "Crime contre l'humanité ou génocide"
    },
    value: 'crimeAgainstHumanityOrGenocide',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: { en: 'Terrorism', fr: 'Terrorisme' },
    value: 'terrorism',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: { en: 'Destruction of property', fr: 'Destruction de biens' },
    value: 'destructionOfProperty',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: {
      en: 'Pillage / Looting of property and /or goods',
      fr: 'Pillage de biens'
    },
    value: 'pillageLootingOfPropertyOrGoods',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: { en: 'Theft', fr: 'Vol' },
    value: 'theft',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: { en: 'Riot / demonstration', fr: 'Émeute / Manifestation' },
    value: 'riotDemonstrations',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: { en: 'Remote violence', fr: 'Violence à distance' },
    value: 'remoteViolence',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: { en: 'Political repression', fr: 'Répression politique' },
    value: 'politicalRepression',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: {
      en: 'Sexual and gender-based violence',
      fr: 'Violence sexuelle et basée sur le genre'
    },
    value: 'sexualGenderBasedViolence',
    filter: { riskTypes: 'conflictSecurity' }
  },
  {
    label: {
      en: 'Misalignment between conservation goals and community priorities',
      fr: 'Discordance entre les objectifs de conservation et les priorités des communautés'
    },
    value: 'conversationAligment',
    filter: { riskTypes: 'environment' }
  },
  {
    label: {
      en: 'Post-mining reclamation and sustainable land use',
      fr: 'Remise en état et utilisation durable des terres après exploitation minière'
    },
    value: 'sustainableLand',
    filter: { riskTypes: 'environment' }
  },
  {
    label: { en: 'Ecosystem degradation', fr: 'Dégradation des écosystèmes' },
    value: 'ecosystemProtection',
    filter: { riskTypes: 'environment' }
  },
  {
    label: {
      en: 'Forest health and sustainability',
      fr: 'Santé et durabilité des forêts'
    },
    value: 'forestHealth',
    filter: { riskTypes: 'environment' }
  },
  {
    label: {
      en: 'Wastewater contamination and water quality',
      fr: "Contamination des eaux usées et qualité de l'eau"
    },
    value: 'wastewaterContamination',
    filter: { riskTypes: 'environment' }
  },
  {
    label: {
      en: 'Soil pollution and contamination',
      fr: 'Pollution et contamination des sols'
    },
    value: 'soilPollution',
    filter: { riskTypes: 'environment' }
  },
  {
    label: { en: 'Air pollution', fr: "Pollution de l'air" },
    value: 'airPollution',
    filter: { riskTypes: 'environment' }
  },
  {
    label: { en: 'Landslides', fr: 'Glissements de terrain' },
    value: 'landslide',
    filter: { riskTypes: 'environment' }
  },
  {
    label: { en: 'Water flooding', fr: 'Inondations' },
    value: 'waterFlooding',
    filter: { riskTypes: 'environment' }
  },
  {
    label: { en: 'Earthquake', fr: 'Tremblement de terre' },
    value: 'earthquake',
    filter: { riskTypes: 'environment' }
  },
  {
    label: {
      en: 'Infrastructure reliability and operational safety',
      fr: 'Fiabilité et sécurité opérationnelle des infrastructures'
    },
    value: 'infrastructureReliability',
    filter: { riskTypes: 'healthSafety' }
  },
  {
    label: {
      en: 'Machines reliability and operational safety',
      fr: 'Fiabilité et sécurité de fonctionnement des machines'
    },
    value: 'machineReliability',
    filter: { riskTypes: 'healthSafety' }
  },
  {
    label: { en: 'Explosives and blasting', fr: 'Explosifs et dynamitage' },
    value: 'explosive',
    filter: { riskTypes: 'healthSafety' }
  },
  {
    label: {
      en: 'Mercury use and production',
      fr: 'Utilisation et production de mercure'
    },
    value: 'mercuryUse',
    filter: { riskTypes: 'healthSafety' }
  },
  {
    label: {
      en: 'Exposure to hazardous, harmful or toxic substances',
      fr: 'Exposition à des substances dangereuses, nocives ou toxiques'
    },
    value: 'exposureToHazardous',
    filter: { riskTypes: 'healthSafety' }
  },
  {
    label: {
      en: 'Exposure to radioactivity',
      fr: 'Exposition à la radioactivité'
    },
    value: 'exposureToRadioactivity',
    filter: { riskTypes: 'healthSafety' }
  },
  {
    label: {
      en: 'Personal Protective Equipment (PPE)',
      fr: 'Équipement de Protection Individuelle (EPI)'
    },
    value: 'ppe',
    filter: { riskTypes: 'healthSafety' }
  },
  {
    label: {
      en: 'Asbence of local participation in decision making',
      fr: 'Absence de participation locale à la prise de décision'
    },
    value: 'localParticipation',
    filter: { riskTypes: 'communitySociety' }
  },
  {
    label: {
      en: 'Resource conflicts regarding land use',
      fr: "Conflits de ressources concernant l'utilisation des terres"
    },
    value: 'resourceConflictsForLand',
    filter: { riskTypes: 'communitySociety' }
  },
  {
    label: {
      en: 'Resource conflicts regarding water use',
      fr: "Conflits de ressources concernant l'utilisation de l'eau"
    },
    value: 'resourceConflictsForWater',
    filter: { riskTypes: 'communitySociety' }
  }
];

export const mapFiltersConfig = {
  location: [
    {
      type: 'input',
      label: 'Dashboard::Search location',
      placeholder: 'Dashboard::Location Name',
      dest: 'locationName',
    },
    {
      type: 'checkbox',
      label: 'Dashboard::Show/hide types of locations',
      dest: 'type',
      options: [
        { label: 'Mine Sites', value: 'mineSite', marker: '/assets/images/dashboard/map-icons/minesites-location-icon.svg', default: true, },
        { label: 'Villages', value: 'village', marker: '/assets/images/dashboard/map-icons/villages-location-icon.svg', default: true, },
        { label: 'Other', value: 'other', marker: '/assets/images/dashboard/map-icons/other-location-icon.svg', default: true, },
      ],
    },
  ],
  event: [
    {
      type: 'radio',
      label: 'Dashboard::Choose period',
      dest: 'period',
      options: [
        {
          label: 'Dashboard::All',
          value: 'all',
          default: true,
        },
        {
          label: 'Dashboard::One Month',
          value: 'monthly',
        },
        {
          label: 'Dashboard::3 Months',
          value: 'threeMonths',
        },
        {
          label: 'Dashboard::12 Months',
          value: 'year',
        },
      ],
    },
    {
      type: 'select',
      label: 'Dashboard::Risk category',
      placeholder: 'Dashboard::Select category',
      dest: 'riskTypes',
      options: riskTypesOptions,
    },
    {
      type: 'select',
      label: 'Dashboard::Risk Type',
      placeholder: 'Dashboard::Select type',
      dest: 'riskSubTypes',
      options: riskSubTypesOptions,
    },
  ],
  datachain: [
    {
      type: 'checkbox',
      label: 'Dashboard::Show/hide types of LIR',
      dest: 'type',
      options: [
        {
          label: 'Dashboard::Individual',
          value: 'individual',
          default: true,
        },
        {
          label: 'Dashboard::Business Entity',
          value: 'businessEntity',
          default: true,
        },
        {
          label: 'Dashboard::Civil society',
          value: 'civilSociety',
          default: true,
        },
      ],
    },
  ],
  risk: [
    {
      type: 'select',
      label: 'Dashboard::Risk category',
      placeholder: 'Dashboard::Select category',
      dest: 'riskTypes',
      options: riskTypesOptions,
    },
    {
      type: 'select',
      label: 'Dashboard::Risk Type',
      placeholder: 'Dashboard::Select type',
      dest: 'riskSubTypes',
      options: riskSubTypesOptions,
    },
    {
      type: 'riskSelector',
      dest: 'riskScore',
      label: 'Dashboard::Filter by risk score',
    }
  ],
}
